import participant from '@/store/event/modules/participant';

export default {
    namespaced: true,
    modules: {
        participant
    }
};
